import React from 'react';

type SkeletonProps = {
    width?: string | number;
    height?: string | number;
};

const Skeleton = ({ width = '60%', height = 14 }: SkeletonProps): JSX.Element => {
    return (
        <span
            className="skeleton-shimmer"
            style={{ width, height, display: 'inline-block' }}
        />
    );
};

export default Skeleton;
